(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-vertical-list-2-slide"] && !Shopify.designMode) return;
  try {
    

$('.collection-list-slid').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 300,
  autoplaySpeed: 2000,
  autoplay: false,
  dots: true,
  arrows:false,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-slide"] && !Shopify.designMode) return;
  try {
    

$('.prod-coll-slide').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  speed: 300,
  autoplaySpeed: 2000,
  autoplay: false,
  dots: true,
  arrows:false,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 750,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});
  
  } catch(e) { console.error(e); }
})();
})();
